/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getBlob.defs'
export { main as default } from './getBlob.defs'
